import { FleLayout } from "../FleLayout"
import { BackArrow, ContinueArrow, SpacerSwitcher, SwitchH1ToH2 } from "../Molecules"
import { FlexRowCenter, Spacer } from "../../atoms/Atoms"
import { IlloPartners } from "../../atoms/Illustrations"
import { Body, BodySmall } from "../../atoms/Bodies"
import { FleLinkWrapper } from "../../atoms/Links"
import { TextLink } from "../../atoms/links/TextLink"
import React from "react"
import L10n from "../../../../lib/carrot-l10n"
import { TopSection } from "../TopSection"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const AboutYourPartnerIntro = ({ next, skip }) => {
  return (
    <FleLayout>
      <TopSection progressStep={3} leftOrBackArrow={<BackArrow />} />
      <FlexRowCenter>
        <IlloPartners />
      </FlexRowCenter>
      <SpacerSwitcher />
      <SwitchH1ToH2>{l`Share your Carrot membership with your partner.`}</SwitchH1ToH2>
      <Spacer height={1} />
      <Body color="black-80">
        {l`Providing details about your partner or spouse helps us better support
        and share relevant content with both of you.`}
      </Body>
      <FleLinkWrapper>
        <ContinueArrow to={next} />
        <TextLink to={skip}>
          <BodySmall color="black-80">Skip section</BodySmall>
        </TextLink>
      </FleLinkWrapper>
    </FleLayout>
  )
}

export { AboutYourPartnerIntro }
